exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Auth__Auth--1TInt{\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\tpadding-top: 100px;\r\n\tflex-grow: 1;\r\n\tbackground: linear-gradient(270deg, #cef2fa 0%, #59bfef 100%);\r\n\t\r\n}\r\n\r\n.Auth__Auth--1TInt > div{\r\n\twidth: 100%;\r\n\tmax-width: 600px;\r\n\tpadding: 0 20px;\r\n}\r\n\r\n.Auth__Auth--1TInt h1{\r\n\tcolor:#fff;\r\n\ttext-align: center;\r\n}\r\n\r\n.Auth__AuthForm--38dS6{\r\n\tbackground: #eee;\r\n\tbox-shadow: 2px 2px 2px rgba(0,0,0,.5);\r\n\tpadding: 15px;\r\n\tborder-radius: 5px;\r\n}", ""]);

// exports
exports.locals = {
	"Auth": "Auth__Auth--1TInt",
	"AuthForm": "Auth__AuthForm--38dS6"
};